module.exports = __webpack_public_path__ + "static/img/header_mtitle.2a93b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/mobile/header_mtitle.png
// module id = 5xKL
// module chunks = 0